(function () {
  const initImageWithTextSlider = (section) => {
    if (!section?.classList.contains("image-with-text-section")) return;

    const sliderEl = section.querySelector(".js-image-with-text-swiper");
    if (!sliderEl) return;

    const paginationEl = section.querySelector(".image-with-text-media-pagination");
    const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;

    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    if (slideCount <= 1) return;

    new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      loop: slideCount > 1,
      allowTouchMove: true,
      watchOverflow: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : false,
    });
  };

  const initAll = () => {
    document
      .querySelectorAll(".image-with-text-section")
      .forEach(initImageWithTextSlider);
  };

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", (event) => {
    initImageWithTextSlider(event.target);
  });
})();
